module.exports = __webpack_public_path__ + "static/images/51282a11541f779fcd2776d0d33d9d55.png";